import React, {useLayoutEffect, useRef, useState} from "react";
import StructuredText from "../custom-structured-text-renderer";
import {Asset, Link} from "../../../../plugins/gatsby-plugin-atollon";
import {graphql} from "gatsby";
import {RightArrow, Bocuse, EdgeBottom1, EdgeTop2} from "../../icons";
import BG from '../../../assets/images/greenwheat-bg.jpg'
import AnimationButton from "./animation-button"

const BasicCta = ({title, richContent, buttons, theme, image, productLanding, burgerOne, burgerTwo, burgerThree, ambassador}) => {
    const edgeTopRef = useRef()
    const edgeBottomRef = useRef()
    const [edgeHeight, setEdgeHeight] = useState()

    useLayoutEffect(() => {
        const handleOffsetHeight = () => {
            setEdgeHeight({
                top: edgeTopRef?.current?.offsetHeight,
                bottom: edgeBottomRef?.current?.offsetHeight
            })
        }

        handleOffsetHeight()

        window.addEventListener('resize', () => handleOffsetHeight());

        return () => {
            window.removeEventListener('resize', () => handleOffsetHeight());
        };
    }, []);

    return (
      <>
          <section className={`basic-cta ${theme || ''}${productLanding ? ' basic-cta--product' : ''}${burgerOne ? ' basic-cta--burger-one' : ''}${burgerTwo ? ' basic-cta--burger-two' : ''}${burgerThree ? ' basic-cta--burger-three' : ''}`}>
              {theme === 'greenwheat' && <div className='basic-cta__bg'><img src={BG} alt="Greenwheat"/></div>}
              {burgerOne && <div className='basic-cta__bg'><Asset asset={image}/></div> }
              {theme === 'woods' && !productLanding && !burgerOne && !burgerTwo && !burgerThree &&
                <div ref={edgeTopRef}
                     style={{top: -(edgeHeight?.top) + 5}}
                     className='basic-cta__edge'>
                    <EdgeTop2 color='#F1F0E4'/>
                </div>}
              { ambassador &&
                <div className='basic-cta__image ambassadors'>
                  <Asset asset={image} />
                </div>
              }
              { !productLanding && !burgerThree &&
                <div className='basic-cta__inner'>
                    <div className='basic-cta__wrapper' data-sal='slide-up' data-sal-duration='1000' data-sal-easing='ease'>
                        {title && <h2>{title}</h2>}
                        {richContent && <StructuredText data={richContent}/>}
                        { buttons?.length > 0 &&
                          <div className='basic-cta__buttons'>
                              {buttons.map((el, i) => (
                                <AnimationButton
                                  key={i}
                                  className={`btn btn--animation ${theme === 'bone' && i === 1 ? 'btn--brown' : ''}`}
                                  to={el.link[0].externalLink ? el.link[0].externalLink : el.link[0].internalLink?.permalink}>
                                    {el.title}
                                    <RightArrow color='#ffffff'/>
                                </AnimationButton>
                              ))
                              }
                          </div>
                        }
                    </div>
                </div>
              }
              {theme === 'woods' && !burgerOne && !burgerTwo &&
                <div ref={edgeBottomRef}
                     style={{bottom: -(edgeHeight?.bottom) + 5}}
                     className='basic-cta__edge'>
                    <EdgeBottom1 color={burgerThree ? '#FFFFFF' : '#F1F0E4'}/>
                </div>}
          </section>
          {
            theme && image && !burgerOne && !burgerTwo && !ambassador &&
            <div className='basic-cta__image'>
                <Asset asset={image}/>
                {theme === 'bone' && <span><Bocuse/></span>}
            </div>
          }
      </>
    )
}

export default BasicCta

export const query = graphql`
fragment BasicCtaProps on DatoCmsBasicCta  {
  ... on DatoCmsBasicCta {
    id
    title
    richContent {
      value
    }
    buttons {
      ...LinkWithTitleProps
    }
    image {
      ...InternalAssetProps
    }
    productLanding
    burgerOne
    burgerTwo
    burgerThree
    ambassador
  }
}`